import React, { Component } from 'react'
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/system";

export default class LoaderBlock extends Component {
    render() {
        return (
                 <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "20vh",
                margin:"auto"
              }}
            >
              <CircularProgress color="success" />
            </Box>
        )
    }
}
